class ProductGallery {
  constructor() {
    this.mainGallery = null;
    this.thumbnailGallery = null;
    this.productForm = document.querySelector('.js-product-form');
    
    this.init();
  }

  init() {
    // Initialize main gallery
    const mainGalleryElement = document.getElementById('product-gallery');
    if (mainGalleryElement) {
      this.mainGallery = new Splide('#product-gallery', {
        type: 'fade',
        perPage: 1,
        perMove: 1,    
        pagination: false,
        arrows: false,
        mediaQuery: 'min',
        breakpoints: {
          1024: {
            pagination: false,
          }
        }
      }).mount();
    }

    // Initialize thumbnail gallery
    const thumbnailGalleryElement = document.getElementById('product-thumbnails');
    if (thumbnailGalleryElement) {
      this.thumbnailGallery = new Splide('#product-thumbnails', {        
        fixedWidth : 56,
        fixedHeight: 56,
        gap : 0,
        rewind : true,
        pagination : false,
        arrows: false,
        isNavigation: true,
        mediaQuery: 'min',
        breakpoints: {
          640: {
            fixedWidth : 72,
            fixedHeight: 72,
          }
        }
      }).mount();
    }

    // Sync galleries
    if (this.mainGallery && this.thumbnailGallery) {
      this.mainGallery.sync(this.thumbnailGallery);
    }

    // Listen for variant changes
    if (this.productForm) {
      this.productForm.addEventListener('variant:changed', this.handleVariantChange.bind(this));
    }
  }

  handleVariantChange(event) {
    const variant = event.detail.variant;
    if (!variant || !variant.featured_media) return;

    const mediaId = variant.featured_media.id;
    const slideIndex = this.findSlideIndex(mediaId);

    if (slideIndex !== -1 && this.mainGallery) {
      this.mainGallery.go(slideIndex);
    }
  }

  findSlideIndex(mediaId) {
    const slides = document.querySelectorAll('#product-gallery .splide__slide');
    return Array.from(slides).findIndex(slide => 
      parseInt(slide.dataset.mediaId) === mediaId
    );
  }
}

// Initialize the gallery
document.addEventListener('DOMContentLoaded', () => {
  new ProductGallery();
});